import {
  Container,
  Logo,
  MenuButton,
  SvgIcon,
  SidebarMenu,
  BackButton,
  Title,
  LoginButton,
} from "./styled";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown } from "antd";
import logo from "../../assets/logo.png";
import SidebarContent from "../Sidebar/SidebarContent";
import { HeaderContext } from "../../containers/MainLayout";
import defaultAvatar from "../../assets/default_avatar.png";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { ReactComponent as ProfileIcon } from "../../assets/user.svg";
import { ReactComponent as SideBarIcon } from "../../assets/sidebar.svg";
import { ReactComponent as LoginIcon } from "../../assets/login.svg";
import { ReactComponent as PenIcon } from "../../assets/pen.svg";
import { ReactComponent as ChatIcon } from "../../assets/chat.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as CommunityIcon } from "../../assets/community.svg";
import { logout } from "../../store/actions/auth.action";
import { useAppDispatch, useAppSelector } from "../../store";
import Avatar from "boring-avatars";
import HomeSidebarContent from "./HomeSidebarContent";

const HeaderComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { me, userExtendData } = useAppSelector((state) => state.authReducer);
  const { backAction, headerTitle } = useContext(HeaderContext);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      key: "my-posts",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white",
            padding: "5px",
            fontWeight: "500",
          }}
        >
          <PenIcon width={16} height={16} />
          My Posts
        </span>
      ),
      onClick: () => {
        if (me?._id || me?.id) {
          navigate(`/user/${me?._id || me?.id}`);
        }
      },
    },
    {
      key: "profile",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white",
            padding: "5px",
            fontWeight: "500",
          }}
        >
          <ProfileIcon width={20} height={20} />
          My Profile
        </span>
      ),
      onClick: () => navigate("/profile"),
    },
    {
      key: "logout",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white",
            padding: "5px",
            fontWeight: "500",
          }}
        >
          <LogoutIcon width={20} height={20} />
          Logout
        </span>
      ),
      onClick: () => handleLogout(),
    },
  ];

  const handleLogout = async () => {
    await dispatch(logout());
  };

  return (
    <>
      <Container>
        {/* Mobile Menu Icon */}
        {location.pathname !== "/booking" && (
          <MenuButton
            position={!!backAction ? "right" : "left"}
            onClick={() => setIsOpen(!isOpen)}
          >
            <SideBarIcon width={22} />
          </MenuButton>
        )}

        {/* Logo */}
        {!!headerTitle ? (
          <Title>{headerTitle}</Title>
        ) : (
          <Logo
            src={logo}
            alt="Logo"
            onClick={() => {
              setIsOpen(false);
              navigate("/", { state: { community: "GLOBAL" } });
            }}
          />
        )}

        {/* Go Back Button */}
        {!!backAction && (
          <BackButton
            onClick={() => {
              setIsOpen(false);
              backAction();
            }}
          >
            <SvgIcon
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </SvgIcon>
          </BackButton>
        )}
        {!!me && !backAction ? (
          <BackButton position="right">
            <Dropdown
              menu={{
                items: menuItems,
                style: {
                  background: "#1a1a1a",
                },
              }}
              placement="topRight"
              trigger={["click"]}
            >
              {userExtendData?.avatarUrl ? (
                <img
                  style={{
                    width: 32,
                    height: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={userExtendData?.avatarUrl}
                />
              ) : (
                <Avatar
                  name={me?.firstName + " " + me?.lastName}
                  variant="beam"
                  size={32}
                />
              )}
            </Dropdown>
          </BackButton>
        ) : (
          <BackButton position="right" onClick={() => navigate("/login")}>
            <LoginIcon width={20} height={20} />
          </BackButton>
        )}
      </Container>

      <SidebarMenu
        isOpen={isOpen}
        position={!!backAction ? "right" : "left"}
        className={isOpen ? "open" : ""}
        ref={menuRef}
      >
        {location.pathname === "/" && (
          <HomeSidebarContent
            openSidebar={isOpen}
            setOpenSidebar={setIsOpen}
            closeAfterClicked
          />
        )}
        {location.pathname.includes("/chat") && (
          <SidebarContent
            openSidebar={isOpen}
            closeAfterClicked
            setOpenSidebar={setIsOpen}
          />
        )}
      </SidebarMenu>
    </>
  );
};

export default HeaderComponent;
